export default "__VITE_ASSET__MkO2Qvuq__"